<template>
  <div class="activities">
    <div class="row">
      <div class="col-12 col-sm-6 text-center text-sm-start">
        <page-title
          v-if="viewTiles === false"
          :title="'Logboek ' + getDate()"
          icon="activities"
        ></page-title>
        <page-title
          v-if="viewTiles === true"
          :title="'Huidige activiteiten'"
          icon="activities"
        ></page-title>
      </div>
      <div class="col-12 col-sm-6  text-center text-sm-end" style="padding-top: 8px; padding-bottom: 8px">
        <span v-if="viewTiles === false">
          <date-range-select class="me-1" type="day" @changeDateRange="setDate($event.dateStart)"></date-range-select>
          <button
            v-if="!isGastouderapp() && isToday()"
            v-on:click="showPresentChildrenOnly = !showPresentChildrenOnly"
            :class="showPresentChildrenOnly ? 'btn-primary' : 'btn-secondary'"
            class="btn me-1"
          >
            Alleen aanwezigen
          </button>
        </span>
        <button v-if="getApplicationSetting('feature_flag_ipad_activities_tiles_view') === '1'" v-on:click="viewTiles = !viewTiles" class="btn btn-secondary me-1">
          <span v-if="viewTiles === false">
            Tegels
          </span>
          <span v-else-if="viewTiles === true">
            Klassiek
          </span>
        </button>
        <button v-if="isAuthorized('communication', 'activities', 'add')" v-on:click="showModal = true; activity = null" class="btn btn-success">
          Nieuw
        </button>
        <span class="d-block d-sm-none" style="padding-top: 12px;"></span>
      </div>
    </div>
    <router-view
      v-if="viewTiles === false && date"
      :showPresentChildrenOnly="showPresentChildrenOnly"
      :date="date" @openModalWithChild="openModalWithChild($event)"
      @openModalWithActivity="openModalWithActivity($event)"
    />
    <activities-tiles v-else-if="viewTiles === true" @openModalWithActivity="openModalWithActivity($event)" />
    <activity-modal
      v-if="showModal"
      :activity="activity"
      :child="child"
      @close="closeActivityModal"
      @saved="activitySaved"
    ></activity-modal>
  </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'
import DateRangeSelect from '@/components/Date-Range-Select'
import ActivitiesTiles from '@/views/activities/Tiles'
import ActivityModal from '@/components/Activity-Modal'

export default {
  name: 'activities',
  components: {
    PageTitle,
    DateRangeSelect,
    ActivitiesTiles,
    ActivityModal
  },
  data () {
    return {
      showModal: false,
      activity: null,
      child: null,
      showPresentChildrenOnly: !this.isGastouderapp(),
      date: null,
      viewTiles: false
    }
  },
  methods: {
    openModalWithChild (child) {
      this.child = child
      this.showModal = true
    },
    openModalWithActivity (activity) {
      this.activity = activity
      this.showModal = true
    },
    closeActivityModal () {
      this.showModal = false
      this.activity = null
      this.child = null
    },
    activitySaved () {
      this.closeActivityModal()
    },
    setDate (date) {
      this.date = date
      this.showPresentChildrenOnly = this.isToday() && !this.isGastouderapp()
    },
    isToday () {
      return this.date === this.$moment().format('YYYY-MM-DD')
    },
    getDate () {
      if (!this.date) {
        return ''
      }
      return this.$moment(this.date).format('ddd D MMM')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
